import { ROUTES } from "@/config/routes/paths";

/** 사이드바 메뉴 + 헤더 타이틀 공통 정의 (key = pathname 첫 세그먼트) */
export const NAV_ITEMS = [
  { key: "client", label: "고객사", href: ROUTES.CLIENT.LIST },
  { key: "site", label: "현장", href: ROUTES.SITE.LIST },
  { key: "account", label: "계정", href: ROUTES.ACCOUNT.LIST },
  { key: "inquiry", label: "도입 문의", href: ROUTES.INQUIRY.LIST },
] as const;
